import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

// Components
import BaseModal from 'react-bootstrap/Modal'

// Styles
import './Modal.scss'

export const Modal = ({
  show,
  title,
  animation,
  backdrop,
  centered,
  className,
  children,
  hasCloseButton,
  ...props
}) => {
  const showHeader = hasCloseButton || !!title
  const classList = useMemo(() => {
    const list = ['x-modal', className]

    return list.join(' ')
  }, [className])

  return (
    <BaseModal
      show={show}
      animation={animation}
      backdrop={backdrop}
      centered={centered}
      className={classList}
      {...props}
    >
      {showHeader && (
        <BaseModal.Header closeButton={hasCloseButton}>
          <div className="title">{title}</div>
        </BaseModal.Header>
      )}

      {children}
    </BaseModal>
  )
}

// Props
Modal.propTypes = {
  title: PropTypes.string,
  show: PropTypes.bool,
  animation: PropTypes.bool,
  backdrop: PropTypes.string,
  centered: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  hasCloseButton: PropTypes.bool,
}

Modal.defaultProps = {
  title: null,
  show: false,
  animation: false,
  backdrop: 'static',
  centered: true,
  children: null,
  className: '',
  hasCloseButton: false,
}

export default Modal
